import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { useAtom } from "jotai";
import {
    openBlockedTimeDialogAtom,
    selectedBuIdAtom
} from "../../atoms/blockedTime";
import { daysArrayToString } from "../../modules/RecurringBookingsUtilityFunctions";

const MobileBlockedTimeCard = ({ blockedTime }) => {
    const [, setBlockedTimeDialog] = useAtom(openBlockedTimeDialogAtom);
    const [, setSelectedBuId] = useAtom(selectedBuIdAtom);

    const handleBookingCardClick = () => {
        setSelectedBuId(blockedTime.buId);
        setBlockedTimeDialog(true);
    };

    return (
        <Card>
            <CardContent
                onClick={() => {
                    handleBookingCardClick();
                }}
            >
                <Typography variant="body2">{blockedTime.dateRange}</Typography>
                <Typography variant="body2">
                    {daysArrayToString(
                        blockedTime.weekDays.split("").map(Number)
                    )}
                </Typography>
                <Typography variant="body2">{blockedTime.timeRange}</Typography>
                {blockedTime?.notes && (
                    <Typography
                        variant="body2"
                        sx={{ fontStyle: "italic", paddingTop: "18px" }}
                    >
                        {" "}
                        {blockedTime.notes}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default MobileBlockedTimeCard;
